import {
  useState, SetStateAction, Dispatch, useEffect,
} from 'react';
import { STEPS, Step, PROGRESS_NODES } from '../utils/constants/progressSteps';
import env from '../utils/env';

const getCurrentFromUrlOrHistory = (locationSource: any):Step => {
  const path = locationSource.location.pathname;
  // Cloudfront adds a trailing slash, but local env does not
  const trailingSlash = path ? path.charAt(path.length - 1) === '/' : false;
  return PROGRESS_NODES.find((s) => {
    const compareUrl = trailingSlash ? `${s.url}/` : s.url;
    return compareUrl === path;
  })
    ?? STEPS.CREATE_ACCOUNT;
};
export function useCurrentStep(history: any) {
  const [currentStep, setCurrentStep]: [
    string,
    Dispatch<SetStateAction<string>>,
  ] = useState(getCurrentFromUrlOrHistory(window).title);

  useEffect(() => {
    if (history) {
      history.listen(() => {
        const step = getCurrentFromUrlOrHistory(history);
        setCurrentStep(step.title);
      });
    }
  }, [history]);

  const goToStep = (nextStep: Step) => {
    setCurrentStep(nextStep.title);
    if (history) {
      history.push(nextStep.url);
    } else {
      window.location.assign(`https://${env.originUrl}/create-account`);
    }
  };

  const goToCreateAccount = () => {
    setCurrentStep(STEPS.CREATE_ACCOUNT.title);
    history.push(STEPS.CREATE_ACCOUNT.url);
  };
  //   DO WE NEED THIS?
  //   const goToPrevStep = () => {}
  return { currentStep, goToStep, goToCreateAccount };
}

export default useCurrentStep;
